import { render } from "./TimeLabel.vue?vue&type=template&id=8b37e7e0&lang=html"
import script from "./TimeLabel.vue?vue&type=script&lang=js"
export * from "./TimeLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__